import { combineReducers } from 'redux'
import authReducer from 'modules/Auth/reducers'
import corporateReducer from 'modules/Roles/reducers'
import driveReducer from 'modules/Drives/reducers'
import userReducer from 'modules/Users/reducers'
import settingsReducer from 'modules/Settings/reducers'
import reportReducer from 'modules/Report/reducers'
import mandatesReducer from 'modules/Mandates/reducers'
import jobRolesPreviewReducer from 'modules/JobPreview/reducer'
import corporateDashboardPage2Reducer from 'modules/CorporateDashboardPage2/reducer'
import assessmentReducer from 'modules/Assessment/reducers'

export default combineReducers({
  auth: authReducer,
  corporate: corporateReducer,
  drives: driveReducer,
  user: userReducer,
  settings: settingsReducer,
  report: reportReducer,
  mandates: mandatesReducer,
  jobRolesPreview: jobRolesPreviewReducer,
  corporateDashboardPage2: corporateDashboardPage2Reducer,
  assessment: assessmentReducer,
})
